export const IconBackLeftArrow: {
  name: 'icon_back_left_arrow-6bb7b91e569a'
} = {
  name: 'icon_back_left_arrow-6bb7b91e569a'
}
